import { Popover, Stack } from "@mui/material";
import { Button } from "components/ButtonNew";
import { IconButton } from "components/IconButton";
import { type IconName } from "components/Icon";
import { useState } from "react";

type EnergyAnalysisChartTypeOption<T extends string> = {
  iconName: IconName;
  label: string;
  value: T;
};

type EnergyAnalysisChartTypeMenuProps<T extends string> = {
  onChange: (value: T) => void;
  options: EnergyAnalysisChartTypeOption<T>[];
  value: T;
};

export const EnergyAnalysisChartTypeMenu = <T extends string>({
  onChange,
  options,
  value,
}: EnergyAnalysisChartTypeMenuProps<T>) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const selected = options.find((option) => option.value === value) ?? options[0];
  if (!selected) return null;
  return (
    <>
      <IconButton
        buttonProps={{
          isActive: Boolean(anchorEl),
          onClick: (event) => setAnchorEl(event.currentTarget),
          size: "sm",
          variant: "tertiary",
        }}
        iconProps={{ iconName: selected.iconName, size: "sm" }}
      />
      <Popover
        PaperProps={{ className: "min-w-[12rem] !p-1" }}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <Stack className="w-full min-w-0 flex-col items-stretch">
          {options.map((option) => (
            <Button
              className="w-full !h-ds-2x justify-start"
              key={option.value}
              onClick={() => {
                onChange(option.value);
                setAnchorEl(null);
              }}
              size="sm"
              startIconName={option.iconName}
              variant={option.value === value ? "secondary" : "tertiary"}
            >
              {option.label}
            </Button>
          ))}
        </Stack>
      </Popover>
    </>
  );
};
